// extracted by mini-css-extract-plugin
export var cardIcon = "_77-5";
export var checkboxCard = "_77-0";
export var checkboxCardSelected = "_77-4";
export var disabled = "_77-2";
export var interactive = "_77-1";
export var outerBorder = "_77-3";
export var spacerMedium = "_77-8";
export var spacerSmall = "_77-7";
export var spacerXsmall = "_77-6";